import PublicAlbumPage from "@/components/audiolab/MainAlbumPage";
import { queryClient } from "@/components/providers";
import {
  albumsControllerAlbumDetail,
  getAlbumsControllerAlbumDetailQueryKey,
} from "@/lib/lutely-api/gen/albums/albums";
import type { DetailAlbumDto } from "@/lib/lutely-api/gen/dtos";
import { ALBUM_ROUTE_DETAIL } from "@/utils/routeUtils";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/@{$CREATOR_SLUG}/$ALBUM_SLUG")({
  ...ALBUM_ROUTE_DETAIL,
  loader: async ({ params }) => {
    let album: DetailAlbumDto;
    try {
      album = await queryClient.fetchQuery({
        queryKey: getAlbumsControllerAlbumDetailQueryKey({
          creatorSlug: params.CREATOR_SLUG,
          albumSlug: params.ALBUM_SLUG,
        }),
        queryFn: () =>
          albumsControllerAlbumDetail({
            creatorSlug: params.CREATOR_SLUG,
            albumSlug: params.ALBUM_SLUG,
          }),
      });
    } catch {
      return { album: null as DetailAlbumDto | null };
    }

    // The API also resolves slugs the album used to answer to, so a hit on a
    // URL that isn't the current one means the release was renamed.
    if (album.slug && album.slug !== params.ALBUM_SLUG) {
      throw redirect({
        to: "/@{$CREATOR_SLUG}/$ALBUM_SLUG",
        params: {
          CREATOR_SLUG: album.creator.slug ?? params.CREATOR_SLUG,
          ALBUM_SLUG: album.slug,
        },
        replace: true,
      });
    }

    return { album };
  },
  component: PublicAlbumPage,
});
